var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.source)?_c('iframe',{attrs:{"src":_vm.source,"title":"YouTube video player","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":"","frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }